import {
  Activity,
  Bike,
  CircleDot,
  Dumbbell,
  Flame,
  Footprints,
  Goal,
  HeartPulse,
  Mountain,
  PersonStanding,
  Sailboat,
  Snowflake,
  Swords,
  TentTree,
  Volleyball,
  Waves,
  type LucideIcon,
} from "lucide-react";
import type { SportDefinition } from "./types";

const iconDefinitions: { id: string; label: string; icon: LucideIcon }[] = [
  { id: "activity", label: "Multisport / activité", icon: Activity },
  { id: "dumbbell", label: "Musculation", icon: Dumbbell },
  { id: "waves", label: "Natation", icon: Waves },
  { id: "mountain", label: "Escalade / montagne", icon: Mountain },
  { id: "bike", label: "Vélo", icon: Bike },
  { id: "footprints", label: "Marche / course", icon: Footprints },
  { id: "person-standing", label: "Gymnastique / yoga", icon: PersonStanding },
  { id: "volleyball", label: "Sport de ballon", icon: Volleyball },
  { id: "goal", label: "Sport avec buts", icon: Goal },
  { id: "swords", label: "Sport de combat", icon: Swords },
  { id: "sailboat", label: "Sport nautique", icon: Sailboat },
  { id: "snowflake", label: "Sport d’hiver", icon: Snowflake },
  { id: "tent-tree", label: "Plein air", icon: TentTree },
  { id: "heart-pulse", label: "Cardio", icon: HeartPulse },
  { id: "flame", label: "Effort intense", icon: Flame },
  { id: "circle-dot", label: "Autre sport", icon: CircleDot },
];

const aliases: Record<string, string> = {
  running: "footprints",
  run: "footprints",
  swimming: "waves",
  swim: "waves",
  strength: "dumbbell",
  weights: "dumbbell",
  climbing: "mountain",
  cycling: "bike",
  bicycle: "bike",
  yoga: "person-standing",
  cardio: "heart-pulse",
};

export const sportIconOptions = iconDefinitions.map(({ id, label }) => ({ id, label }));

export function SportGlyph({ icon }: { icon?: string }) {
  const requested = (icon || "activity").trim().toLocaleLowerCase("fr");
  const normalized = aliases[requested] ?? requested;
  const Icon = iconDefinitions.find((item) => item.id === normalized)?.icon ?? Activity;
  return <Icon aria-hidden="true" />;
}

export function sportIconFor(sports: SportDefinition[] | undefined, reference: string) {
  const normalized = reference.trim().toLocaleLowerCase("fr");
  return sports?.find((sport) => sport.id === reference || sport.name.trim().toLocaleLowerCase("fr") === normalized)?.icon ?? "activity";
}
